import { render, staticRenderFns } from "./integralCommodity.vue?vue&type=template&id=7942e62e&scoped=true"
import script from "./integralCommodity.vue?vue&type=script&lang=js"
export * from "./integralCommodity.vue?vue&type=script&lang=js"
import style0 from "./integralCommodity.vue?vue&type=style&index=0&id=7942e62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7942e62e",
  null
  
)

export default component.exports